module.exports = __webpack_public_path__ + "static/media/gallaxy-background.93cc3cb6.webp";